import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/components/dialogue/radix-dialog";
import { LeaveRequest } from "src/redux/types/_attendance.type";
import LeaveDetails from "./LeaveDetails";
import LeaveBalance from "./LeaveBalance";
import { useLeaveBalance } from "../hooks/useLeaveBalance";
import { Balances, LeaveType } from "../type";

function getBalance(balances: Balances, type: LeaveType) {
  return balances[type];
}

interface LeaveRequestDetailsDialogProps {
  leave: LeaveRequest;
  open: boolean;
  close: () => void;
}

const LeaveDetailDialog = ({
  leave,
  open,
  close,
}: LeaveRequestDetailsDialogProps) => {
  
  const { data: leaveBalance, isLoading } = useLeaveBalance(leave.employee_id);

  const balance =
    leaveBalance && getBalance(leaveBalance?.balances, leave.type);

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-card max-w-5xl">
        <DialogHeader>
          <DialogTitle>Leave Details</DialogTitle>
          <div className="grid grid-cols-2 gap-2">
            {isLoading ? (
              <div className="flex items-center justify-center p-4">
                <span className="loading loading-ring loading-md"></span>
              </div>
            ) : (
              <>
                <LeaveDetails leave={leave} balance={balance} />
                <LeaveBalance employeeId={leave.employee_id} />
              </>
            )}
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default LeaveDetailDialog;
